import { ResourceModel } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";
import { ModelTagsMixin } from "./mixins/ModelTagsMixin";
import { STORE_KEYS } from "../../other/constants/StoreKeys.jsx";
import { ModelEntityReminderStatusMixin } from "./mixins/ModelEntityReminderStatusMixin.jsx";
import { getAging, getSwivuEmptyStringValue } from "../../other/utils/utils.jsx";
import { HasIconMixin } from "./mixins/HasIconMixin.jsx";
import { HasChecklistMixin } from "./mixins/HasChecklistMixin.jsx";
import HasCompanyCam from "@/bryntum-lib/models/mixins/HasCompanyCam.jsx";
import { BoardUser } from "@/modern/components/user-avatar";

export class Client extends HasProjectMixin(HasCompanyCam(ModelTagsMixin(ModelEntityReminderStatusMixin(HasChecklistMixin(HasIconMixin(ResourceModel)))))) {

  declare isPhantom: boolean;
  declare id: number | string;
  declare name: string;
  declare address: string;
  declare city: string;
  declare website: string;
  declare notes: string;
  declare order: number;
  declare archived: boolean;
  declare creatorId: number;
  declare createdAt: Date;
  declare updaterId: number;
  declare updatedAt: Date;
  declare checklistCount: number;
  declare checklistStatus: number;
  declare creatorRecord: BoardUser;
  declare updaterRecord: BoardUser;
  declare isClient: boolean;

  static get $name() {
    return "Client";
  }

  static get relations() {
    return {
      creatorRecord: {
        foreignKey: "creatorId",
        foreignStore: STORE_KEYS.boardUserStore,
      },
      updaterRecord: {
        foreignKey: "updaterId",
        foreignStore: STORE_KEYS.boardUserStore,
      },
    }
  }

  static get fields() {
    return [
      "id",
      "name",
      { name: "address", convert: getSwivuEmptyStringValue },
      { name: "city", convert: getSwivuEmptyStringValue },
      { name: "website", convert: getSwivuEmptyStringValue },
      "notes",
      "order",
      { name: "archived", type: "boolean", defaultValue: false },
      { name: "creatorId", dataSource: "creator", type: "number"},
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updaterId", dataSource: "updater", type: "number"},
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
      { name: "aging", persist: false },
    ];
  }

  static swivuGetFieldOriginalSourceName(fieldName: string) {
    const fieldsMaps: Record<string, string> = {}
    return fieldsMaps[fieldName] || super.swivuGetFieldOriginalSourceName?.(fieldName);
  }

  get companyCamIntegrationStore() {
    return this.project?.clientIntegrationsStore;
  }

  get entityVisibleName() {
    return "Client";
  }

  get tagStoreName() {
    return STORE_KEYS.clientTagValuesStore;
  }

  get tasks() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (this.project as any)?.extraTaskStore
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .findByField("clientId", this.id)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .map((d: any) => d.data);
  }

  get entityType() {
    return 'clientId' as const;
  }

  get aging() {
    return getAging(this.get("createdAt"));
  }

  get swivuUnlinkPromptConfig () {
    return {
      record: this,
      relatedRecords: this.tasks,
      relatedEntityModelKey: "client"
    };
  }
}

// @ts-expect-error - exposeProperties is internal method
Client.exposeProperties();
